import { get } from 'api/utils';
import { PREFIX_API_VER_2 } from 'configs/localData/constant';

export async function generateEULAApi() {
  return get(`/crm/config/page-eula`, null, PREFIX_API_VER_2);
}
